module.exports = __webpack_public_path__ + "img/corzo-3.735ab6ac.jpg";